module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Thank you","subtitle":"Good choice! We’re passing you and your details to {provider} to complete your application","raisin":"Good choice! We’re passing you and your details to Raisin.ie to complete your application"}}')
  delete Component.options._Ctor
}
